import { useQuery } from "@tanstack/react-query";
import type { RecordId } from "../type";
import { getSupplierBlacklistDetail } from "@/apis/supplier";

export function useBlacklistRecordDetail(recordId: RecordId) {
  const result = useQuery({
    queryKey: ["blacklistRecordDetail", recordId],
    queryFn: () => getSupplierBlacklistDetail(recordId!),
    enabled: !!recordId,
  });

  return result.data?.data.data;
}
